const Plugin = require("common/Plugin");
const LogonController = require("./LogonController");
const LogonView = require("./LogonView");
const LogonMessageView = require("./LogonMessageView");
const LogonHandler = require("./LogonHandler");
const LogonRequestFailureHandler = require("./LogonRequestFailureHandler");
const BrowserPluginPropertyProvider = require("../nac/BrowserPluginPropertyProvider");

const LogonPlugin = function(clientConfig) {
    const self = this;
    let $menuEntry;

    this.start = function() {
        const logonMessageView = new LogonMessageView();
        const logonView = new LogonView(clientConfig.isTouch());

        const logonController = new LogonController(logonMessageView, logonView);
        const logonHandler = new LogonHandler(new LogonRequestFailureHandler());

        logonController.registerHandler(logonHandler, "7.1.0");
        logonHandler.addPropertyProvider("flash-version", new BrowserPluginPropertyProvider("Flash", clientConfig));
        logonHandler.addPropertyProvider("java-version", new BrowserPluginPropertyProvider("Java", clientConfig));
        logonHandler.addPropertyProvider("silverlight-version", new BrowserPluginPropertyProvider("Silverlight", clientConfig));

        self.registerController(logonController);
        self.addOptionsMenuEntry($.t("common::logoff.title"), logonController.logoffUser, 0).then(function(entry) {
            $menuEntry = entry;
        });
    };

    $(document).on("userauthenticated", function(event, session) {
        if ($menuEntry && $menuEntry.toggle) {
            $menuEntry.toggle(!session.isCertOnly);
        }
    });
};

LogonPlugin.prototype = Plugin;

module.exports = LogonPlugin;


//////////////////
// WEBPACK FOOTER
// ./logon/LogonPlugin.js
// module id = 37
// module chunks = 0